import { frontendURL } from '../../../../helper/URLHelper';
import AccountBrandingIndex from './Index.vue';
import SettingsWrapper from '../SettingsWrapper.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/account-branding'),
      meta: { permissions: ['administrator'] },
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'account_branding_settings',
          component: AccountBrandingIndex,
          meta: {
            permissions: ['administrator'],
            platformService: 'custom_branding',
          },
        },
      ],
    },
  ],
};
